<template>
  <div class="intercept">
    <header-component noinit />
    <div class="intercept-content">
      <img src="@/assets/image/guyu_icon@2x.png" alt="" />
      <p>
        尊敬的机构用户您好，为了升级教学质量，请您使用<a href="//guyu.codemao.cn">谷雨系统平台</a>
      </p>
      <ul>
        <li><span>谷雨平台官方网站：</span><span class="align-left">guyu.codemao.cn</span></li>
        <li><span>咨询电话：</span><span class="align-left">4006655169</span></li>
        <li><span>咨询邮箱：</span><span class="align-left">xinlingshou@codemao.cm</span></li>
      </ul>
      <a class="to-guyu" href="//guyu.codemao.cn">立即前往谷雨平台</a>
    </div>
  </div>
</template>

<script>
import HeaderComponent from '@/components/header'

export default {
  name: 'intercept',
  components: { HeaderComponent }
}
</script>

<style lang="scss" scoped>
.intercept {
  background: #fff;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 1001;
  &-content {
    text-align: center;
    height: calc(100% - 60px);
    width: 464px;
    margin: 0 auto;
    img {
      width: 400px;
      height: 360px;
      margin-top: 47px;
    }
    p {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #333333;
      line-height: 21px;
      a {
        color: #00c4aa;
      }
    }
    ul {
      width: 464px;
      background: #f4f4f4;
      border-radius: 4px;
      text-align: center;
      padding: 15px;
      margin-top: 15px;
    }
    span {
      display: inline-block;
      width: 154px;
      text-align: right;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #999999;
      line-height: 24px;
    }
  }
  .to-guyu {
    display: inline-block;
    width: 166px;
    height: 36px;
    line-height: 36px;
    margin-top: 23px;
    text-align: center;
    background: #ffa21c;
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
  .align-left {
    text-align: left;
  }
}
</style>
